/**
 * Formatted Number
 *
 * Will format numbers into US format (comma/decimal)
 */

export default function formatToUSNumber(number) {
  if (number === void 0) {
    number = '';
  }
  const parts = number.toString().split('.');
  const whole = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  const decimal = parts[1] ? '.' + parts[1] : '';
  return whole + decimal;
}